import { render } from "./MenuDesktopLinks.vue?vue&type=template&id=c7863150&scoped=true"
import script from "./MenuDesktopLinks.vue?vue&type=script&lang=js"
export * from "./MenuDesktopLinks.vue?vue&type=script&lang=js"

import "./MenuDesktopLinks.vue?vue&type=style&index=0&id=c7863150&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7863150"]])

export default __exports__